export const CHAT_FOCUS_TIMESTAMP_KEY = 'chatFocusTimestamp';
export const EMAIL_FOCUS_TIMESTAMP_KEY = 'emailFocusTimestamp';
